<template>
  <div class="vx-col ml-auto mr-auto xl:w-1/2 w-full m-base">
    <vx-card title="Meterstanden doorgeven">
      <div v-if="!finished">
        <contract-info
          class="mb-base"
          :contract="contractData"
          :hide-recurring-amount="true"
          v-if="contractData"
        ></contract-info>

        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          errorColor="rgba(var(--vs-danger), 1)"
          :title="null"
          :subtitle="null"
          finishButtonText="Versturen"
          nextButtonText="Volgende"
          backButtonText="Terug"
          @on-complete="onComplete"
        >
          <tab-content
            title="Meterstanden invullen"
            class="mb-5"
            icon="feather icon-trending-up"
            :before-change="validateStep1"
          >
            <div class="vx-col  ml-auto mr-auto lg:w-1/2 w-full">
              <vx-card title="Datum" class="mb-base" v-if="tokenData.show_date">
                <div class="vx-row">
                  <div class="vx-col w-full mt-5">
                    <ValidationProvider
                      :name="'Datum'"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <datepicker
                        placeholder="Select Date"
                        v-model="readingDate"
                        :format="customFormatter"
                      ></datepicker>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card>

              <!-- tab 1 content -->
              <validation-observer ref="observerStep1">
                <form @submit.prevent="">
                  <vx-card
                    :title="$t(`Producttypes.${connection.type}`)"
                    v-for="connection in connectionData.connections"
                    :key="connection.id"
                    class="mb-base"
                  >
                    <div class="vx-col w-full mt-5 text-right">
                      <vs-button
                        @click="connection.popupActive = true"
                        color="primary"
                        type="border"
                        >Toon historische standen</vs-button
                      >
                    </div>

                    <vs-popup
                      title="Historische standen"
                      :active.sync="connection.popupActive"
                    >
                      <meter-reading-card
                        :id="connection.id"
                      ></meter-reading-card>
                    </vs-popup>
                    <div
                      class="vx-row"
                      v-for="register in connection.registers"
                      :key="register.tariff_type_id"
                    >
                      <div class="vx-col   w-full mt-5">
                        <ValidationProvider
                          :name="`'${register.tariff_description}'`"
                          rules="required|numeric"
                          v-slot="{ errors }"
                        >
                          <vs-input
                            :label="
                              `${register.tariff_description} (in ${$t(
                                `Productunity.${connection.type}`
                              )})`
                            "
                            v-model="register.reading"
                            class="w-full"
                            type=""
                          />
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </vx-card>
                </form>
              </validation-observer>
            </div>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content
            title="Controleren"
            class="mb-5"
            icon="feather icon-check-circle"
          >
            <div class="vx-col  ml-auto mr-auto xl:w-1/2 w-full mt-5">
              <vx-card class="mb-base">
                <table>
                  <tr>
                    <th>Datum:</th>
                    <td>{{ customFormatter(connectionData.date) }}</td>
                  </tr>
                </table>
              </vx-card>
              <vx-card
                class="mb-base"
                v-for="connection in connectionData.connections"
                :key="connection.id"
                :title="$t(`Producttypes.${connection.type}`)"
              >
                <table>
                  <tr
                    v-for="register in connection.registers"
                    :key="register.tariff_type_id"
                  >
                    <th>{{ register.tariff_description }}:</th>
                    <td>
                      {{ register.reading }}
                      {{ $t(`Productunity.${connection.type}`) }}
                    </td>
                  </tr>
                </table>
              </vx-card>
            </div>
          </tab-content>
        </form-wizard>
      </div>

      <div v-if="finished">
        <vs-alert color="success" title="Meterstanden" active="true">
          We hebben je meterstanden ontvangen. Je ontvangt hier straks een
          bevestiging van in je mail.
        </vs-alert>
      </div>
    </vx-card>
  </div>
</template>

<script>
import contractInfo from "@/components/contractInfo";
import { mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";

import {
  ValidationObserver,
  extend,
  localize,
  ValidationProvider
} from "vee-validate";

import { required, numeric } from "vee-validate/dist/rules";
import nl from "vee-validate/dist/locale/nl.json";
import MeterReadingCard from "../components/MeterReadingCard.vue";
import moment from "moment";
extend("numeric", numeric);
extend("required", required);
localize("nl", nl);
export default {
  data() {
    return {
      serverErrors: null,
      finished: false,
      tokenData: {},
      contractData: null,
      connectionData: {
        date: moment().format("YYYY-MM-DD"),
        connections: []
      }
    };
  },
  components: {
    contractInfo,
    FormWizard,
    TabContent,
    ValidationObserver,
    ValidationProvider,
    MeterReadingCard,
    Datepicker
  },
  computed: {
    ...mapState(["contracts"]),
    readingDate: {
      get() {
        return this.connectionData.date;
      },
      set(value) {
        this.connectionData.date = moment(value).format("YYYY-MM-DD");
      }
    }
  },
  props: {
    token: {
      type: String,
      required: true
    }
  },

  watch: {
    token: {
      immediate: true,
      deep: true,
      handler() {
        //this.$router.go();
      }
    }
  },

  methods: {
    async onComplete() {
      try {
        await this.$http().post(
          `/api/MeterReading/request/${this.token}`,
          this.connectionData
        );
        if (this.tokenData.is_recurring_amount_advise) {
          this.$router.push(`/${this.token}/recurringamount/false`);
        } else {
          this.finished = true;
        }
      } catch (err) {
        if (err.response && err.response.status == 400) {
          this.serverErrors = err.response.data;
        } else {
          this.showError(
            "Je meterstanden konden niet verstuurd worden.",
            false,
            err
          );
        }
      }
    },
    getContractData() {
      if (this.contracts != null) {
        this.contractData = this.contracts.find(
          c => c.id == this.tokenData.contract_id && c.active
        );
      }
    },
    async getRequest() {
      let tokenReq = await this.$http().get(
        `/api/MeterReading/request/${this.token}`
      );
      this.tokenData = tokenReq.data;
      this.getContractData();
      this.$store.watch(state => state.contracts, this.getContractData);
      let connections = [];

      if (this.tokenData.connection_ids) {
        for (
          let index = 0;
          index < this.tokenData.connection_ids.length;
          index++
        ) {
          const connection_id = this.tokenData.connection_ids[index];
          let connectionReq = await this.$http().get(
            `/api/Connections/${connection_id}`
          );
          connections.push(connectionReq.data);
        }
      } else {
        let connectionsReq = await this.$http().get(
          `/api/Contracts/${this.tokenData.contract_id}/connections?metertypesearch=conventional`
        );
        connections = connectionsReq.data;
      }

      connections.forEach(element => {
        element.popupActive = false;
      });
      this.connectionData.connections = connections;
    },
    customFormatter(date) {
      return moment(date)
        .locale("nl")
        .format("DD-MM-YYYY");
    },
    async validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.observerStep1.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    }
  },
  async mounted() {
    this.getRequest();
  }
};
</script>

<style></style>
